import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { IBreadcrumbItem } from '../models/breadcrumb';

interface BreadcrumbComponentProps {
    items: Array<IBreadcrumbItem>;
    separator: string;
}

const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = (props) => {
    return (
        <Breadcrumb style={{ margin: '0 0' }} separator={props.separator}>
            {props.items.map((item, index) => (
                <Breadcrumb.Item key={index}>
                    {item?.onClick ? (
                        // If onClick is provided, render a clickable element
                        <span onClick={item.onClick} style={{ cursor: 'pointer', color: '#000' }}>
                            {item.title}
                        </span>
                    ) : item?.path ? (
                        // If path is provided, render a link
                        <Link to={item.path}>{item.title}</Link>
                    ) : (
                        // Otherwise, render plain text
                        <>{item.title}</>
                    )}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};

export default BreadcrumbComponent;
